import React, { useEffect, useState } from 'react';
const images = ['https://cdn.magicpatterns.com/uploads/4NU2VHzvRkakdir83LyW8G/unnamed_(6).jpg', 'https://cdn.magicpatterns.com/uploads/k9PvhRxSfEEaxmmUfqiEL9/unnamed_(3).jpg', 'https://cdn.magicpatterns.com/uploads/uEBi6tkmRSNwsedtx85pjm/unnamed_(4).jpg', 'https://cdn.magicpatterns.com/uploads/oZdvNMsqWgJpUuBNvAs8MS/unnamed_(5).jpg'];
export function BackgroundSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <div className="relative w-full h-64 overflow-hidden" data-id="element-25">
      {images.map((img, idx) => <div key={idx} className={`absolute inset-0 transition-opacity duration-1000 ${idx === currentIndex ? 'opacity-100' : 'opacity-0'}`} data-id="element-26">
          <img src={img} alt="" className="w-full h-full object-cover grayscale opacity-20" data-id="element-27" />
        </div>)}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#f5f5f7]/50 to-[#f5f5f7]" data-id="element-28" />
    </div>;
}